// Get all elements with class 'background__media__video-wrapper'
var videoWrappers = document.querySelectorAll('.background__media__video-wrapper');

// Iterate through each video wrapper
videoWrappers.forEach(function(videoWrapper) {
    var mainVideo = videoWrapper.querySelector('video');
    var desktopSrc = mainVideo.getAttribute("desktopsrc");
    var mobileSrc = mainVideo.getAttribute("mobilesrc");

    if (!mobileSrc) {
        mobileSrc = desktopSrc;
    }

    if (window.innerWidth < 980) {
        var source = document.createElement('source');
        source.setAttribute('type', 'video/mp4');
        source.setAttribute('src', mobileSrc);
        mainVideo.appendChild(source);
    } else {
        var source = document.createElement('source');
        source.setAttribute('type', 'video/mp4');
        source.setAttribute('src', desktopSrc);
        mainVideo.appendChild(source);
    }
});
